import axios, { AxiosResponse } from 'axios';
import * as utils from './apiUtils';
import { AdminAbilityIndexResponse } from '@/models/apis/ability/adminAbilityResponse';

export default {
  adminIndex(): Promise<AxiosResponse<AdminAbilityIndexResponse>> {
    return axios.get(utils.getApiUrl('/admin/abilities'));
  },
};
